import {
	AppBar,
	Grid,
	Hidden,
	IconButton,
	Toolbar,
	Typography,
} from '@material-ui/core';
// Import { ReactComponent as AvatarIcon } from "src/assets/images/avatar.svg";
import {
	AccountCircle as AvatarIcon,
	Menu as MenuIcon,
} from '@material-ui/icons';
import { type RootState } from 'src/store';
import { initialsFor, useIsMobile } from 'src/helpers';
import { useSelector } from 'react-redux';
import LogoImg from 'src/assets/images/ccn4.png';
import clsx from 'clsx';
import useStyles from './Topbar-styles';

interface TopbarProps {
	open: boolean;
	handleDrawerOpen: () => void;
}

function Topbar({ handleDrawerOpen, open }: TopbarProps) {
	const classes = useStyles();
	const isMobile = useIsMobile();
	const user = useSelector((state: RootState) => state.auth.data);

	return (
		<AppBar className={classes.appBar} color={'primary'} elevation={0}>
			<Toolbar>
				<Grid alignItems={'center'} container justify={'space-between'}>
					<Grid className={classes.logoContainer} item xs={6}>
						<Hidden lgUp>
							<IconButton
								aria-label={'open drawer'}
								className={clsx(
									classes.menuButton,
									open && classes.hide,
								)}
								color={'inherit'}
								edge={'start'}
								onClick={handleDrawerOpen}
							>
								<MenuIcon />
							</IconButton>
						</Hidden>

						<img
							alt={'logo'}
							className={classes.logo}
							src={LogoImg}
						/>
					</Grid>

					<Grid
						alignItems={'center'}
						container
						item
						justify={'flex-end'}
						xs={6}
					>
						<AvatarIcon
							height={24}
							style={{ marginRight: 8 }}
							width={24}
						/>

						<Typography noWrap>
							{' '}
							{isMobile
								? initialsFor(
										`${user.firstname || ''} ${
											user.lastname || ''
										}`,
								  )
								: `${user.firstname || ''} ${
										user.lastname || ''
								  }`}{' '}
						</Typography>
					</Grid>
				</Grid>
			</Toolbar>
		</AppBar>
	);
}

export default Topbar;
